import React, { FC } from 'react';
import { Progress } from 'antd';

export const ProgressComponent: FC<{ percent: number }> = ({ percent }) => {
	return (
		<Progress
			strokeColor={{
				'0%': '#65ABFF',
				'100%': '#FB827A',
			}}
			percent={percent}
			showInfo={false}
		/>
	);
};
